module.exports = __webpack_public_path__ + "img/ambulancia_down_selected.ae97ac5f.svg";